import type { ReactNode } from "react";
import "./FlatSelect.scss";
import type { Item } from "@/shared/components/generic/items.ts";
import FlatSelectItem from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/flat-select/FlatSelectItem.tsx";

interface Properties<T> {
  title?: string;
  items: Item<T>[];
  selectedItem?: Item<T>;
  onSelectItem: (item: Item<T>) => void;
}

export default function FlatSelect<T>(props: Properties<T>): ReactNode {
  return (
    <div className="flat-select">
      {props.title !== undefined && (
        <div className="flat-select-title">{props.title}</div>
      )}
      {props.items.map((item) => (
        <FlatSelectItem
          key={item.key}
          label={item.label}
          selected={item === props.selectedItem}
          onSelect={() => {
            props.onSelectItem(item);
          }}
        />
      ))}
    </div>
  );
}
